export const SENTENCE_FIX_WIDTH = 800;
